module.exports = __webpack_public_path__ + "img/SER-A-2-IV.cf769d73.png";